import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import TaxGroup from "../../../../utilities/data/model/TaxGroup";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";

const UNKNOWN_TAX_GROUP = "Unknown TaxGroup";

export type TaxGroupIdToNameProps = TextPropTypes & {
  taxGroupId: string;
};

export const TaxGroupIdToName = ({
  taxGroupId,
  ...props
}: TaxGroupIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const taxGroup = await database
          .get<TaxGroup>("tax_groups")
          .find(taxGroupId);

        setName(taxGroup.name ?? UNKNOWN_TAX_GROUP);
      } catch (err) {
        setName(UNKNOWN_TAX_GROUP);
      }
    })();
  }, [taxGroupId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
